import { helper } from '@ember/component/helper';

import { qpDateRangeIsInvalid } from 'rise-ui/utils/qp-date.js';

export default helper(function qpDateRangeInvalidHelper([ availableDates, dates ]) {
  return qpDateRangeIsInvalid(availableDates, dates);
});
